import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";
import Card from "../ui/Card";
import SectionTitle from "../ui/SectionTitle";

export default function Education() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14" id="education">
      <SectionTitle kicker="Background" title="Education" />

      <div className="grid gap-5 md:grid-cols-2">
        <Card>
          <div className="text-base font-semibold text-white">Education</div>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            {DATA.education.map((e) => (
              <li key={e.item} className="flex gap-2">
                <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-indigo-400/80" />
                <span>{e.item}</span>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </div>
  );
}
